module.exports = __webpack_public_path__ + "static/media/climate-change.cf528023.png";